import { SearchResult } from '@/types/home';
import {
  FeatherBriefcase,
  FeatherFile,
  FeatherFolder,
  FeatherMail,
  FeatherMessageCircle,
  FeatherSend,
} from '@subframe/core';

export interface DropdownBuscaProps {
  className?: string;
}

export const TYPE_CONFIG: Record<
  SearchResult['type'],
  {
    icon: React.ReactNode;
    label: string;
    badgeVariant: 'brand' | 'neutral' | 'error' | 'warning' | 'success';
  }
> = {
  notificacao: {
    icon: <FeatherMail className="text-heading-3 font-heading-3 text-brand-600" />,
    label: 'Notificação',
    badgeVariant: 'brand',
  },
  processo: {
    icon: <FeatherBriefcase className="text-heading-3 font-heading-3 text-brand-600" />,
    label: 'Processo',
    badgeVariant: 'warning',
  },
  negociacao: {
    icon: <FeatherMessageCircle className="text-heading-3 font-heading-3 text-brand-600" />,
    label: 'Negociação',
    badgeVariant: 'success',
  },
  peticionamento: {
    icon: <FeatherSend className="text-heading-3 font-heading-3 text-brand-600" />,
    label: 'Peticionamento',
    badgeVariant: 'error',
  },
  documento: {
    icon: <FeatherFile className="text-heading-3 font-heading-3 text-brand-600" />,
    label: 'Documento',
    badgeVariant: 'neutral',
  },
};

export const DEFAULT_TYPE_CONFIG = {
  icon: <FeatherFolder className="text-heading-3 font-heading-3 text-brand-600" />,
  label: 'Outro',
  badgeVariant: 'neutral' as const,
};

export function resolveRoute(result: SearchResult): string | null {
  const route = result.metadata?.route as string | undefined;
  const numeroProcesso = result.metadata?.numeroProcesso as string | undefined;

  if (route) {
    return route;
  }

  switch (result.type) {
    case 'processo':
      return numeroProcesso ? `/peticionamento/acompanhamento/${numeroProcesso}` : null;
    case 'notificacao':
      return `/notificacoes/${result.id}`;
    case 'negociacao':
      return `/negociacoes/${result.id}`;
    case 'peticionamento':
      return numeroProcesso ? `/peticionamento/solicitacao/${numeroProcesso}` : null;
    case 'documento':
      return `/contratos/${result.id}`;
    default:
      return null;
  }
}
